import { useEffect, useState } from 'react';
import api from '~/services';
import { ContactGroupList } from '~/types/accountInfo';

export default function useContactGroups() {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState<ContactGroupList>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactGroups = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await api.contacts.groups.list();

        if (response.data._embedded.length) {
          // FIXME: We should check posibility to move this camel case logic to services.js using camelcaseKeys library
          const groupsInCamelCase = response.data._embedded.map(
            (e: {
              group_id: any;
              group_name: any;
              delete_lock: any;
              owner_id: any;
              contact_id: any;
            }) => ({
              groupId: e.group_id,
              groupName: e.group_name,
              name: e.group_name,
              deleteLock: e.delete_lock,
              ownerId: e.owner_id,
              contacts: e.contact_id, // This props contains the contact ids
            })
          );

          setGroups(groupsInCamelCase);
        }
      } catch (err) {
        setError((err as Error)?.message || 'Error to fetch contact groups.');
      } finally {
        setLoading(false);
      }
    };

    fetchContactGroups();

    return () => {};
  }, [setLoading, setError, setGroups]);

  return { loading, error, groups };
}
